import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const MessageBubble = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 23.999 24"
			style={{
				width: "100%",
				height: "100%",
			}}>
			<path
				d="M7279.847,18218v0l-6.966-5.76H7265a4.005,4.005,0,0,1-4-4V18198a4.005,4.005,0,0,1,4-4h16a4.005,4.005,0,0,1,4,4v10.238a4.005,4.005,0,0,1-4,4h-1.152V18218Zm-1.847-17a2,2,0,1,0,2,2A2,2,0,0,0,7278,18201Zm-5,0a2,2,0,1,0,2,2A2,2,0,0,0,7273,18201Zm-5,0a2,2,0,1,0,2,2A2,2,0,0,0,7268,18201Z"
				transform="translate(-7261 -18194)"
				style={{ fill: "currentcolor" }}
			/>
		</svg>
	</i>
);

MessageBubble.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
MessageBubble.defaultProps = {
	className: "",
	style: {},
};

export default MessageBubble;
export { MessageBubble };
